 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01_COVER from '@/components/xhtml/01_cover'
 import XHTML02_TITLE from '@/components/xhtml/02_title'
 import XHTML03_COPY from '@/components/xhtml/03_copy'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML05_FRONTSPICE from '@/components/xhtml/05_frontspice'
 import XHTML06_TIME from '@/components/xhtml/06_time'
 import XHTML07_INTRO from '@/components/xhtml/07_intro'
 import XHTML08_PROLOGUE from '@/components/xhtml/08_prologue'
 import XHTML09_CH01 from '@/components/xhtml/09_ch01'
 import XHTML10_CH02 from '@/components/xhtml/10_ch02'
 import XHTML11_CH03 from '@/components/xhtml/11_ch03'
 import XHTML12_CH04 from '@/components/xhtml/12_ch04'
 import XHTML13_CH05 from '@/components/xhtml/13_ch05'
 import XHTML14_CH06 from '@/components/xhtml/14_ch06'
 import XHTML15_CH07 from '@/components/xhtml/15_ch07'
 import XHTML16_CH08 from '@/components/xhtml/16_ch08'
 import XHTML17_CH09 from '@/components/xhtml/17_ch09'
 import XHTML18_CH10 from '@/components/xhtml/18_ch10'
 import XHTML19_NOTES from '@/components/xhtml/19_notes'
 import XHTML20_BIB from '@/components/xhtml/20_bib'
 import XHTML21_ACK from '@/components/xhtml/21_ack'
 import XHTML22_AUTHOR from '@/components/xhtml/22_author'
 import XHTML23_PLATES from '@/components/xhtml/23_plates'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/05_frontspice",
 			"name" : "xhtml/05_frontspice",
 			"component" : XHTML05_FRONTSPICE
 		},
 		{
 			"path" : "/xhtml/06_time",
 			"name" : "xhtml/06_time",
 			"component" : XHTML06_TIME
 		},
 		{
 			"path" : "/xhtml/07_intro",
 			"name" : "xhtml/07_intro",
 			"component" : XHTML07_INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js